<template>
  <div class="user">
    <div class="container">
      <div class="aside">
        <div class="avatar-block">
          <div class="avatar-bg">
            <img :src="userinfo.avatar" :alt="userinfo.nickname" class="avatar-img">
          </div>
          <div class="nickname">{{ userinfo.nickname }}</div>
          <div class="desc">{{ userinfo.phone }}</div>
        </div>
        <ul class="nav-list">
          <li class="nav-item" :class="{ 'active': navIndex === index }" v-for="(item, index) in navList" :key="index"
            @click="onTab(index)">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="page-content">
        <div style="margin-bottom: 10px;margin-left: 10px;display: flex;align-items: center">
          <span>余额：</span>
          <span class="content" style="margin-right: 10px">{{ userinfo.money }}</span>
          <el-button type="text" @click="$refs.deposit.onOpen()">充值</el-button>

        </div>
        <div v-if="navIndex === 0">
          <Account @onAuth="(index) => onTab(index)" />
        </div>
        <div v-else-if="navIndex === 1">
          <MyOrder />
        </div>
        <div v-else-if="navIndex === 2">
          <Roll />
        </div>
        <div v-else-if="navIndex === 3">
          <Finance />
        </div>

        <div v-else-if="navIndex === 4">
          <!--          <Invite/>-->
          <News />

        </div>
        <div v-else-if="navIndex === 5">
          <Work />
        </div>
        <div v-else-if="navIndex === 6">
          <Approve />
        </div>
        <div v-else-if="navIndex === 7">
          <Invoice />
        </div>
        <div v-else-if="navIndex === 8">
          <AwsOrder />
        </div>

      </div>
    </div>
    <Dialog title="钱包充值" ref="deposit">
      <Deposit @tab="onTabMoney" />
      <div class="pay-button" slot="btn">
      </div>
    </Dialog>
  </div>
</template>
<script>
import Account from './Account.vue'
import MyOrder from './MyOrder.vue'
import Roll from './Roll.vue'
import News from './News.vue'
import Work from './Work.vue'
import Approve from './Approve.vue'
import Dialog from './Dialog.vue'
import Deposit from './Deposit.vue'
import Finance from "@/components/Finance.vue";
import Invoice from "@/components/Invoice.vue";
import AwsOrder from './AwsOrder.vue'

export default {
  name: 'Index',
  components: {
    Invoice,
    Account,
    MyOrder,
    Roll,
    News,
    Work,
    Approve,
    Dialog,
    Deposit,
    Finance,
    AwsOrder
  },
  data() {
    return {
      depositVisible: true,
      userinfo: {},
      nickname: "花酱",
      navIndex: 0,
      navList: ['账户管理', '订单管理', '我的套餐', '财务管理', '站内消息', '我的工单', '实名认证', '开票记录', 'aws套餐']
    }
  },
  created() {

    this.getUserInfo()
  },
  mounted() {
    this.curIdx = this.$route.params.index || 0
  },

  methods: {

    getUserInfo() {
      this.$api.user.getUserInfo().then(res => {
        this.userinfo = res.data
      })
    },
    onTab(index) {
      this.navIndex = index
    },
    onTabMoney(data) {
      this.money = data.money
    }
  }
}
</script>

<style scoped>
.user {
  background-color: #dfe2e9;
  padding-top: 120px;
  /* 为固定菜单留出空间 */
}

.container {

  display: flex;
  width: 80%;
  height: calc(100vh - 140px);
  padding-bottom: 20px;
}

.aside {
  width: 260px;
  background-color: #f1f5f8;
  padding: 32px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;


}

.avatar-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}

.avatar-bg {
  width: 80px;
  height: 80px;
  background: #e0e4ea;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.avatar-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.nickname {
  font-size: 16px;
  font-weight: 500;
  color: #222;
  margin-bottom: 4px;
}

.desc {
  font-size: 13px;
  color: #999;
  margin-bottom: 8px;
}

.nav-list {
  width: 100%;
  margin-top: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.nav-item {

  height: 48px;
  line-height: 48px;
  color: #222;
  font-size: 16px;
  text-align: left;
  padding-left: 40px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  position: relative;
}

.nav-item.active {
  background: #2682ff;
  color: #fff;
  font-weight: 500;
}


.page-content {
  flex: 1;
  background: #fff;
  padding: 32px;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  align-self: stretch;
}

@media (max-width: 900px) {
  .user {
    flex-direction: column;
  }

  .container {
    flex-direction: column;
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
    gap: 16px;
    align-items: stretch;
  }

  .aside,
  .page-content {
    width: 100%;
    margin: 0;
    min-width: 0;
    overflow-x: hidden;
  }

  .aside {
    padding: 16px 0 0 0;
    position: static;
    max-height: none;
    overflow-y: visible;
  }

  .page-content {
    padding: 20px;
    min-height: 400px;
    max-height: none;
    overflow-y: visible;
  }
}
</style>
